import {$dom} from '../../helpers/dom';
import {$events} from '../../helpers/events';
import {
	createElementFromHTML,
	formatBytes,
	isElement,
	loop,
	preventDefault, replaceAll
} from '../../helpers/_utilities';
import {$style} from '../../helpers/style';

const {
	exist,
	callAll,
	get,
	attr,
	remove
} = $dom;

export function uploadFiles(
	rootSelector = '.js-upload-file',
	resultsOutputSelector = '.js-upload-file-results',
	resultSelector = '.js-upload-file-result',
	removeButtonAttr = 'data-remove-file-id',
	templateSelector = '.js-upload-file-result-template'
) {

	if (exist(rootSelector)) {

		function fileUploader(targetElement, targetIdentifier) {
			let idCounter = 0, filesToUpload = [];

			const
				fileTemplate = get(templateSelector, targetElement).innerHTML,
				output = get(resultsOutputSelector, targetElement)
			;

			function checkOutputView() {
				$style.set(output, 'display', filesToUpload.length > 0 ? 'block' : 'none');
			}

			function _handleUpload(event) {
				loop(Array.from(event.target.files), file => {
					idCounter++;
					const id = `${targetIdentifier}-${idCounter}`;

					filesToUpload.push({id, file});

					let template;

					template = replaceAll(fileTemplate, '{fileName}', file.name);
					template = replaceAll(template,'{fileSize}', formatBytes(file.size));
					template = replaceAll(template, '{fileId}', id);

					output.append(createElementFromHTML(template));
				});

				event.target.value = null;
				checkOutputView()
			}

			function _handleDelete(event) {
				const btn = event.target.closest(`[${removeButtonAttr}]`);

				if (isElement(btn)) {
					preventDefault(event);

					const
						id = attr(btn, removeButtonAttr),
						indOf = filesToUpload.map(f => f.id).indexOf(id)
					;

					filesToUpload.splice(indOf, 1);
					remove(btn.closest(resultSelector));

					checkOutputView()
				}
			}

			$events.delegate
				.on('change', targetElement, _handleUpload)
				.on('click tap', targetElement, _handleDelete)
			;

			function clear() {
				filesToUpload = filesToUpload.filter(f => f.id.indexOf(targetIdentifier) !== 0);
				get(resultsOutputSelector, targetElement).innerHTML = '';
			}

			function destroy() {
				$events.delegate
					.off('change', targetElement, _handleUpload)
					.off('click tap', targetElement, _handleDelete)
				;
			}

			checkOutputView();

			return {
				clear,
				destroy,
				get files() {
					return filesToUpload
				}
			};
		}

		let served = [];
		const
			init = () => {
				callAll(rootSelector, (root, index) => {
					served.push({
						element: root,
						uploader: fileUploader(root,`file-id-${index + 1}`)
					});
				});
			},
			destroy = () => {
				loop(served, elem => {
					const {uploader} = elem;
					uploader.clear();
					uploader.destroy();
				});

				served = [];
			}
		;

		return {init, destroy, get served() {return served}}
	}
	return null;
}
